import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useGlobalContext } from "../../../Config";
import FormBusquedaCliente from "../components/FormBusquedaCliente";
import FormBusquedaProductos from "../components/FormBusquedaProductos";
import CotizacionesTable from "../components/CotizacionesTable";
import ClientesTable from "../../client/components/ClientesTable.js";
import UseScrollOnStateChange from "../../../shared/hooks/useScrollOnStateChange.js";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../shared/ui/Loader.js";
import moment from "moment";
import { ReportService } from "../../../services/ReportService.js";
import {
  getProductosByFiltro,
  crearCotizacion,
  getDetalleCotizacionByIdCotizacion,
} from "../../../services/CotizacionService.js";
import useCotizaciones from "../../../shared/hooks/useCotizaciones.js";
import {
  mapEmpresas,
  mapTipos,
  mapDateFilters,
  validarFiltrosProductos,
} from "../../../utilities/filtrosBusqueda.js";

const Cotizacion = (props) => {
  const [additionalSelection] = useState(false);
  const [alias, setAlias] = useState("");
  const [cliente, setCliente] = useState("");
  const [clienteLocal] = useState(false);
  const [clientes, setClientes] = useState("");
  const [criterioBusqueda, setCriterioBusqueda] = useState(false);
  const [desde, setDesde] = useState(null);
  const [displayConfirmation, setDisplayConfirmation] = useState(false);
  const [dni, setDni] = useState("");
  const [empresa, setEmpresa] = useState("TODAS");
  const [empresaArrendadora, setEmpresaArrendadora] = useState(null);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [hasta, setHasta] = useState(null);
  const [isBuscarVisible] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isSearchFormVisible] = useState(false);
  const [isTarifaVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [nombreFantasia, setNombreFantasia] = useState("");
  const [nombreRepresentante, setNombreRepresentante] = useState("");
  const [razonSocial, setRazonSocial] = useState("");
  const [rut, setRut] = useState("");
  const [tipoProducto, setTipoProducto] = useState("");

  // VARIABLES ESTATICAS //
  const navigate = useNavigate();
  const location = useLocation();

  const empresas = [
    { name: "TODAS", value: "TODAS" },
    { name: "ALTAMIRA", value: "Altamira" },
    { name: "LA SIEMBRA", value: "LA SIEMBRA" },
  ];

  const [tiposProducto, setTiposProducto] = useState([]);

  const { baseUrl } = useGlobalContext();

  const op = useRef(null);
  const toast = useRef();
  const reportService = new ReportService();
  const [exporting, setExporting] = useState(false);

  const usuarioId = sessionStorage.getItem("usuario_id");
  const { cotizaciones, loading2, getCotizaciones } = useCotizaciones(
    baseUrl,
    usuarioId,
    ["1", "2"],
    setLoading
  );

  const handleExportExcel = async () => {
    try {
      setExporting(true);
      await reportService.exportDetalleCotizaciones(baseUrl, ["1", "2"]);
      toast.current?.show({
        severity: "success",
        summary: "Exportación exitosa",
        detail: "Se descargó el archivo detalle_cotizaciones.xlsx",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo exportar el archivo Excel",
        life: 3000,
      });
    } finally {
      setExporting(false);
    }
  };

  useEffect(() => {
    getCotizaciones();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const searchProductos = async () => {
    setLoading(true);
    try {
      const validacion = validarFiltrosProductos({ empresa, tipoProducto, desde, hasta });
      if (!validacion.valid) {
        alert(validacion.message);
        return;
      }

      const empresasArray = mapEmpresas(empresa);
      const tiposArray = mapTipos(tipoProducto);
      const { desdeFiltro, hastaFiltro } = mapDateFilters(desde, hasta);

      const data = await getProductosByFiltro(baseUrl, {
        empresas: empresasArray,
        fechaInicio: desdeFiltro,
        fechaTermino: hastaFiltro,
        tipos: tiposArray,
      });

      if (!Array.isArray(data.productos)) {
        console.error("Data.productos no es array:", data.productos);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  UseScrollOnStateChange(clientes, "clientesDataTable");
  UseScrollOnStateChange(isSearchFormVisible, "clienteSeleccionado");

  const toggleFormVisibility = () => {
    setIsFormVisible(true);
  };

  const handleFormClose = () => {
    setIsFormVisible(false);
    navigate("/cotizacion");
  };

  const handleRowClick = async (rowData) => {
    const idCotizacion = rowData.id;

    // Function to format date, ensuring the output is always in 'yyyy-mm-dd'
    const formatDate = (date, inputFormat) => {
      const parsedDate = moment(date, inputFormat);
      return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
    };

    // Format the 'desde' and 'hasta' properties using the formatDate function
    const formattedDesde = formatDate(rowData.desde, "DD/MM/YYYY");
    const formattedHasta = formatDate(rowData.hasta, "DD/MM/YYYY");
    if (rowData.estado === "INGRESADA") {
      let newUrl = `/selectProductos?idCotizacion=${idCotizacion}&idCliente=${rowData.cliente.id}&selected=true&activeIndex=1`;
      navigate(newUrl);
    } else {
      try {
        setLoading(true);
        const data = await getDetalleCotizacionByIdCotizacion(baseUrl, idCotizacion);

        if (data.mensaje === "OK") {
          let newUrl = `/revisarCotizacion?idCliente=${rowData.cliente.id}&idCotizacion=${idCotizacion}&desde=${formattedDesde}&hasta=${formattedHasta}`;
          navigate(newUrl);
        } else {
          alert(data.mensaje);
        }
      } catch (error) {
        console.error(error);
        alert("Hubo un error al crear la cotización");
      } finally {
        setLoading(false);
      }
    }
  };

  const crearCotizacionHandler = async () => {
    try {
      setLoading(true);
      const data = await crearCotizacion(baseUrl, {
        idCliente: cliente.id,
        idCreador: usuarioId,
        empresaArrendadora,
      });
      if (!data.respuesta) {
        alert(data.mensaje);
      } else {
        const newUrl = `/selectProductos?idCotizacion=${data.idCotizacion}&idCliente=${cliente.id}&selected=true&activeIndex=1`;
        navigate(newUrl);
      }
    } catch (error) {
      console.error(error);
      alert(error.message || "Hubo un error al crear la cotización");
    } finally {
      setLoading(false);
    }
  };

  const toggleSearchFormVisibility = () => {
    if (!empresaArrendadora) {
      alert("No ha seleccionado ninguna empresa arrendadora");
      return;
    }
    setDisplayConfirmation(false);
    crearCotizacionHandler();
  };

  const hanldeCriterioBusqueda = (e) => {
    setCriterioBusqueda(e.value);
    setNombreRepresentante("");
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
          <Button
            icon="pi pi-pencil"
            label="Editar"
            className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
            onClick={() => handleRowClick(rowData)}
            outlined
          />
      </div>
    );
  };

  const handleSelectCliente = (rowData) => {
    setCliente(rowData);
    setDisplayConfirmation(true);
  };

  const toggle = (event) => {
    op.current.toggle(event);
  };

  const confirmationDialogFooter = (
    <>
      <Button
        type="button"
        label="Cerrar"
        icon="pi pi-times "
        onClick={() => setDisplayConfirmation(false)}
        className="p-button p-button-rounded p-button-outlined"
      />
      <Button
        type="button"
        label="Confirmar"
        icon="pi pi-check"
        onClick={toggleSearchFormVisibility}
        className="p-button p-button-rounded p-button-success"
        autoFocus
        raised
      />
    </>
  );


  useEffect(() => {
    if (location.state?.toggleFormVisibility) {
      toggleFormVisibility();
      if (location.state?.rutCliente) {
        setRut(location.state.rutCliente);
      }
    }
  }, [location.state]);

  return (
    <div className="grid">
      <div className="col-12">
        <div className="card">
          <h4 style={{ marginBottom: "5px" }}>Borradores</h4>
          <h6 style={{ marginTop: "5px" }}>¿Cómo vamos?</h6>
          {isFormVisible && (
            <div className="card">
              <Button
                label=" Volver"
                icon="pi pi-arrow-left"
                rounded
                outlined
                onClick={handleFormClose}
              />
              {!isBuscarVisible && (
                <FormBusquedaCliente
                  criterioBusqueda={criterioBusqueda}
                  hanldeCriterioBusqueda={hanldeCriterioBusqueda}
                  clienteLocal={clienteLocal}
                  rut={rut}
                  setRut={setRut}
                  razonSocial={razonSocial}
                  setRazonSocial={setRazonSocial}
                  alias={alias}
                  setAlias={setAlias}
                  nombreFantasia={nombreFantasia}
                  setNombreFantasia={setNombreFantasia}
                  dni={dni}
                  setDni={setDni}
                  isValid={isValid}
                  setIsValid={setIsValid}
                  nombreRepresentante={nombreRepresentante}
                  setNombreRepresentante={setNombreRepresentante}
                  onClientesFound={(clientesEncontrados) => {
                    setClientes(clientesEncontrados);
                    setFiltersApplied(true);
                  }}
                />
              )}

              {filtersApplied && (
                <>
                  {loading ? (
                    <>
                      <Loader />
                    </>
                  ) : (
                    <ClientesTable
                      clientes={clientes}
                      setClientes={setClientes}
                      loading={loading}
                      handleSelectCliente={handleSelectCliente}
                      id="clientesDataTable"
                      isMantenedor={false}
                    />
                  )}
                </>
              )}

              <div className="col-12 md:col-12">
                <Dialog
                  visible={displayConfirmation}
                  onHide={() => setDisplayConfirmation(false)}
                  style={{ width: "450px" }}
                  modal
                  header="Selección de Empresa"
                  footer={confirmationDialogFooter}
                  closeOnEscape
                  dismissableMask
                >
                  <div
                    style={{
                      color: "#333",
                      marginBottom: "20px",
                      textAlign: "center",
                      fontSize: "1.1em"
                    }}
                  >
                    Por favor, seleccione una Empresa Arrendadora para continuar
                  </div>
                  <div className="flex align-items-center justify-content-center">
                    <Dropdown
                      id="empresaArrendadora"
                      value={empresaArrendadora}
                      onChange={async (e) => {
                        setEmpresaArrendadora(e.value);
                      }}
                      options={empresas.filter(
                        (empresa) => empresa.value !== "TODAS"
                      )}
                      optionLabel="name"
                      placeholder="Empresas"
                      className="w-full"
                      emptyFilterMessage="No se encontraron empresas"
                      emptyMessage="No hay empresas disponibles"
                    />
                  </div>
                </Dialog>
              </div>

              {isSearchFormVisible && !additionalSelection && (
                <>
                  <FormBusquedaProductos
                    baseUrl={baseUrl}
                    cliente={cliente}
                    empresa={empresa}
                    setEmpresa={setEmpresa}
                    empresas={empresas}
                    tipoProducto={tipoProducto}
                    setTipoProducto={setTipoProducto}
                    tiposProducto={tiposProducto}
                    setTiposProducto={setTiposProducto}
                    desde={desde}
                    setDesde={setDesde}
                    hasta={hasta}
                    setHasta={setHasta}
                    isTarifaVisible={isTarifaVisible}
                    searchProductos={searchProductos}
                    loading={loading}
                  />
                  <div className="p-fluid formgrid grid" id="clienteSeleccionado" ></div>
                </>
              )}
            </div>
          )}
          <Toast ref={toast} />
        </div>
      </div>

      <div className="col-12">
          <OverlayPanel ref={op} appendTo={document.body} showCloseIcon style={{width: '60%'}}>
            <img src="\assets\demo\images\mapa.png" alt="nature1" style={{width: '100%'}}/>
          </OverlayPanel>{" "}
          {isFormVisible ? (
            <></>
          ) : (
            <>
              <div className="card">
                <Button
                  label="Nueva Cotización"
                  icon="pi pi-plus"
                  className="mr-2 mb-2 p-button-rounded p-button"
                  onClick={toggleFormVisibility}
                  raised
                />
                <Button
                  label="Ver Mapa"
                  icon="pi pi-map"
                  className="mr-2 mb-2 p-button-rounded"
                  onClick={toggle}
                  raised
                  severity="info"
                />
                <Button
                  label="Exportar Excel"
                  icon="pi pi-file-excel"
                  className="mr-2 mb-2 p-button-rounded p-button-success"
                  onClick={handleExportExcel}
                  loading={exporting}
                  disabled={exporting}
                />
                <CotizacionesTable
                  cotizaciones={cotizaciones}
                  loading={loading || loading2}
                  actionBodyTemplate={actionBodyTemplate}
                  handleRowClick={handleRowClick}
                />
              </div>
            </>
          )}
        </div>
    </div>
  );
};

export default Cotizacion;
